import {apiGet, apiPost, apiPut, apiDelete, apiPatch} from './api'

export type WebhookEventType = 'private_message' | 'group_message' | 'friend_request'

export type WebhookEventScope = {
    type: WebhookEventType
    scope: 'all' | 'selected'
    contactWxids?: string[]
    labelIds?: number[]
}

export type WebhookConfig = {
    id: string
    accountWxid: string
    url: string
    enabled: boolean
    secret?: string
    events: WebhookEventScope[]
    consecutiveFailures: number
    disabledReason?: string
    createdAt: number
    updatedAt: number
}

export type DeliveryRecord = {
    id: string
    webhookId: string
    event: WebhookEventType
    timestamp: number
    httpStatus?: number
    success: boolean
    retryCount: number
    error?: string
    lastRetryAt?: number
}

export type WebhookCreateInput = {
    accountWxid: string
    url: string
    secret?: string
    events: WebhookEventScope[]
}

export type WebhookUpdateInput = {
    accountWxid?: string
    url?: string
    secret?: string
    events?: WebhookEventScope[]
}

export async function fetchWebhooks(wxid: string): Promise<WebhookConfig[]> {
    return apiGet<WebhookConfig[]>(`/webhooks?wxid=${encodeURIComponent(wxid)}`)
}

export async function createWebhookApi(wxid: string, data: WebhookCreateInput): Promise<WebhookConfig> {
    return apiPost<WebhookConfig>(`/webhooks?wxid=${encodeURIComponent(wxid)}`, data)
}

export async function updateWebhookApi(wxid: string, id: string, data: WebhookUpdateInput): Promise<WebhookConfig> {
    return apiPut<WebhookConfig>(`/webhooks/${id}?wxid=${encodeURIComponent(wxid)}`, data)
}

export async function deleteWebhookApi(wxid: string, id: string): Promise<void> {
    await apiDelete(`/webhooks/${id}?wxid=${encodeURIComponent(wxid)}`)
}

export async function toggleWebhookEnabled(wxid: string, id: string, enabled: boolean): Promise<void> {
    await apiPatch(`/webhooks/${id}/enabled?wxid=${encodeURIComponent(wxid)}`, {enabled})
}

export async function fetchDeliveryLogs(wxid: string, id: string): Promise<DeliveryRecord[]> {
    return apiGet<DeliveryRecord[]>(`/webhooks/${id}/logs?wxid=${encodeURIComponent(wxid)}`)
}
